import { Link } from 'react-router-dom';

export default function NamenLernen() {
  const buttonClasses = 'flex-1 px-6 py-4 text-lg font-semibold rounded-xl shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500';

  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <header className="mb-10">
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Namen lernen</h1>
        <p className="text-gray-600">Wählen Sie einen Modus, um die Namen Ihrer Schülerinnen und Schüler spielerisch zu üben.</p>
      </header>

      <div className="grid gap-6 md:grid-cols-2">
        <Link
          to="/namen-lernen/quiz"
          className={`${buttonClasses} bg-primary-600 text-white hover:bg-primary-700 text-center flex items-center justify-center`}
        >
          Quiz
        </Link>
        <Link
          to="/namen-lernen/snake"
          className={`${buttonClasses} bg-white border border-gray-200 text-primary-700 hover:bg-gray-50 text-center flex items-center justify-center`}
        >
          Snake
        </Link>
      </div>
    </div>
  );
}
